export default "__VITE_ASSET__CjGBmblK__"